<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>档案管理</el-breadcrumb-item>
      <el-breadcrumb-item>账单数据</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="selectFrom" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="selectFrom.meterPointName" placeholder="请输入计量点名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="selectFrom.userName" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker @change="changeMonth" size="small" v-model="selectFrom.month" type="month" value-format="yyyy-MM"
          placeholder="选择月">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getData">搜索</el-button>
        <el-button size="small" type="primary" @click="handleEdit()">生成账单</el-button>
        <el-button size="small" type="infor" @click="exportData()">导出</el-button>

      </el-form-item>
    </el-form>

    <!-- 数据列表 -->
    <el-table size="small" row-key="id" :data="dataList" :height="tableHeight" @selection-change="getIds" v-loading="loading"
      ref="table" border element-loading-text="拼命加载中" style="width: 100%;" :header-cell-style="this.$store.state.headerCss">
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="meterPointName" label="计量点名称">
      </el-table-column>
      <el-table-column prop="meterPoint" label="计量点通讯地址">
      </el-table-column>
      <el-table-column prop="unitPrice" label="单价">
      </el-table-column>
      <el-table-column prop="magnification" label="倍率">
      </el-table-column>
      <el-table-column prop="dataValue" label="用电量(kWh)">
      </el-table-column>
      <el-table-column prop="userName" label="用户">
      </el-table-column>
      <el-table-column prop="billMoney" label="账单费用">
      </el-table-column>
      <el-table-column prop="billDate" label="账单时间">
      </el-table-column>
    </el-table>
    <Pagination v-bind:child-msg="selectFrom" @callFather="callFather"></Pagination>
    <!-- 生成账单界面 -->
    <el-dialog title="生成账单" :visible.sync="addFormVisible" width="30%" @click='addFormVisible = false'>
      <el-form :model="dataForm" label-width="90px">
        <el-form-item label="单价:">
          <el-input size="small" v-model="dataForm.unitPrice" placeholder="请输入单价称"></el-input>
        </el-form-item>

        <el-form-item label="月份:">
          <el-date-picker :disabled="true" size="small" v-model="dataForm.month" type="month" value-format="yyyy-MM"
            placeholder="选择月">
          </el-date-picker>
        </el-form-item>

      </el-form>


      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='addFormVisible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="setLoading" class="title" @click="carateBill()">确认</el-button>
      </div>
    </el-dialog>








  </div>
</template>

<script>
  import {
    generateMonthBill,
    selectFinalMonthBillData,
    generateFinalMonthBill,
    selectMonthBillData
  } from '../../api/energyMG'
  import {} from '../../api/analysisMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        tableHeight: 0,
        loading: false,
        setLoading: false,
        addFormVisible: false,
        dataForm: {
          unitPrice: '',
          month: '',
          meterInfoIds: ""
        },
        dataList: [],
        selectFrom: {
          userName: "",
          currentPage: 1,
          pageSize: 10,
          total: 0,
          meterPointName: "",
          month: ""
        }


      }
    },
    components: {
      Pagination,

    },

    created() {

      this.dataForm.month = this.getLastMonthYestdy()
      this.selectFrom.month = this.getLastMonthYestdy()
      this.getData()
    },
    mounted() {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 260
      })
    },

    methods: {

      getLastMonthYestdy() {
        var date = new Date(); //        1    2    3    4    5    6    7    8    9   10    11   12月
        var daysInMonth = new Array([0], [31], [28], [31], [30], [31], [30], [31], [31], [30], [31], [30], [31]);
        var strYear = date.getFullYear();
        var strDay = date.getDate();
        var strMonth = date.getMonth() + 1;
        if (strYear % 4 == 0 && strYear % 100 != 0) { //一、解决闰年平年的二月份天数   //平年28天、闰年29天//能被4整除且不能被100整除的为闰年
          daysInMonth[2] = 29;
        }
        if (strMonth - 1 == 0) //二、解决跨年问题
        {
          strYear -= 1;
          strMonth = 12;
        } else {
          strMonth -= 1;
        }

        strDay = Math.min(strDay, daysInMonth[strMonth]);

        if (strMonth < 10) //给个位数的月、日补零
        {
          strMonth = "0" + strMonth;
        }
        if (strDay < 10) {
          strDay = "0" + strDay;
        }

        // return strYear+"-"+strMonth+"-"+strDay;
        return strYear + "-" + strMonth;

      },

      exportData() {

      },
      changeMonth() {
        this.dataForm.month = this.selectFrom.month
        this.$refs.table.clearSelection
      },
      getIds(e) {

        this.dataForm.meterInfoIds = e.map(item => item.meterId).join(',')
        this.dataForm.month = e[0].billDate

      },
      callFather(parm) {
        this.selectFrom.currentPage = parm.currentPage
        this.selectFrom.pageSize = parm.pageSize
        this.getData()
      },

      getData() {
        this.loading = true
        selectMonthBillData(this.selectFrom).then(res => {
          this.loading = false
          if (res.status == 1) {
            this.dataList = res.data.data
            this.selectFrom.total = res.data.totalCount
          }
        })
      },
      handleEdit() {
        if (this.dataForm.meterInfoIds.length == 0) {
          this.$message.warning('请选择计量点')
          return
        }
        this.addFormVisible = true
      },
      carateBill() {
        this.setLoading = true
        generateFinalMonthBill(this.dataForm).then(res => {
          this.setLoading = false
          if (res.status == 1) {
            this.$message.success('操作成功')
            this.addFormVisible = false
          } else {
            this.$message.error(res.msg)
          }
        })
      },

      selectMonthBillData() {

      }

    }
  }
</script>

<style>
  .stepBox {
    margin-bottom: 20px;
    display: flex;
  }

  .zhubiao .el-table__body tr.current-row>td {
    background: #79bbff;
  }

  .stepItem {
    display: flex;
    cursor: pointer;
    margin-right: 10px;
    line-height: 14px;
  }

  .stepItem:hover {
    color: #409EFF;
  }

  .treel {
    padding: 0 20px;
    font-size: 13px;
  }

  .gs {
    height: 100px;
  }

  .treel i {
    font-size: 14px;
  }

  .treel /deep/ .el-tree-node {
    white-space: normal !important;
  }

  .treel /deep/ .el-tree-node__content {
    height: auto;
    padding: 6px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/archives/dataBill1.vue